<template>
  <vs-row
    vs-justify="center"
    vs-align="center"
    class="full-height login-register-bg"
  >
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      class="login-register-box"
      vs-lg="12"
      vs-xs="12"
    >
      <img
        class="logo-cliente"
        src="@/assets/images/logo/login_logo.png"
        alt=""
      />
      <vs-card class="mb-0" style="border-radius: 15px; padding-top: 80px">
        <vs-alert
          v-if="errorsList.length"
          class="mb-3 mt-2"
          color="danger"
          :active="inputValid"
        >
          <b>Por favor corrige los siguientes errore(s):</b>
          <ul class="common-list">
            <li v-for="error in errorsList" :key="error">{{ error }}</li>
          </ul>
        </vs-alert>
        <form @submit="checkForm" novalidate="true">
          <vs-input
            icon-after="true"
            size="large"
            class="w-100 mb-4 mt-2 vs-input-large user-input"
            icon="person"
            placeholder="Ingrese identificación o email"
            v-model="email"
            type="text"
          />
          <InputPassword
            class="w-100 vs-input-large"
            placeholder="Ingrese contraseña"
            v-model="pwd"
          />
          <div class="d-flex pt-3 pb-3">
            <vs-checkbox v-model="remember">Recuérdame</vs-checkbox>
            <a style="color: #2962ff" class="ml-auto" :href="composedLink">
              ¿Has olvidado tu contraseña?</a
            >
          </div>
          <button
            class="btn-block btn btn-with-loader btn-primary submit-button"
            type="submit"
            @click.stop.prevent="checkForm"
          >
            <span class="spin-loader" v-if="loading"></span>
            <span v-if="!loading"> Iniciar sesión </span>
          </button>
        </form>

        <!-- Sección para SSO OAuth 2.0 con Microsoft -->
        <div class="text-center mt-3" v-if="showAzureButton">
          <div class="separator">o inicia sesión con</div>
          <button
            class="btn-block btn btn-outline-secondary mt-3 oauth-button"
            :disabled="loading"
            @click="loginWithMicrosoft"
          >
            <img
              src="@/assets/images/icons/microsoft-logo.png"
              alt="Microsoft"
              class="ms-logo"
            />
            Microsoft
          </button>
        </div>

        <div class="d-flex justify-content-center mt-3">
          ¿No tienes una cuenta? &nbsp;
          <router-link to="/public/view/register"> Crea una cuenta</router-link>
        </div>
        <!-- linea de credenciales beta -->
        <hr class="custom-hr" />
        <div class="mt-2 text-center">
          <b>Power by</b>
          <a
            style="text-decoration: none; color: black"
            href="https://www.accesspark.co"
          >
            Accesspark.co
          </a>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { clearSession } from '@/axiosConfig'
import { ROUTES } from '@/global/api_routes'
import { SESSION_VARS } from '@/global/constants'
import md5 from 'md5'
import InputPassword from '../../components/Shared/InputPassword.vue'
import OAuthEndpoints from '@/endpoints/core/OAuthEndpoints'
import { consumeCookie } from '@/helpers/cookies'

export default {
  name: 'Login',
  components: {
    InputPassword
  },
  data: () => ({
    loading: false,
    showAzureButton: false,
    msg: 'Login Here',
    remember: false,
    email: '',
    pwd: '',
    errorsList: [],
    home: '/view/start'
  }),
  mounted() {
    clearSession()
  },
  watch: {
    email(newEmail) {
      this.email = newEmail.toLowerCase()
    }
  },
  computed: {
    composedLink() {
      if (this.origin) {
        return `/public/view/forgot`
      }
      return '#'
    }
  },
  created() {
    this.getOrigin()
    this.checkAzureConfig()
    clearSession()

    // Verificar si venimos del callback de OAuth
    if (
      window.location.pathname.includes('/login/oauth2/code/azure') ||
      window.location.search.includes('code=')
    ) {
      this.processOAuthCallback()
    }
  },
  methods: {
    getOrigin() {
      this.origin = location.origin
    },
    checkAzureConfig() {
      this.loading = true
      OAuthEndpoints.checkAzureConfig().then((result) => {
        this.showAzureButton = result === true
        this.loading = false
      })
    },
    checkForm: function(e) {
      e.preventDefault()
      this.errorsList = []
      if (!this.email) {
        this.errorsList.push(this.$t('loginWords.alertMessages.emailRequired'))
      }
      if (!this.pwd) {
        this.errorsList.push(this.$t('loginWords.alertMessages.passwordRequired'))
      }
      if (!this.errorsList.length) {
        this.login(e)
      }
    },
    login(e) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return
        }
        const send = {
          email: this.email,
          secret: md5(this.pwd)
        }
        this.loading = true
        this.$http
          .post(ROUTES.GLOBAL.LOGIN, send)
          .then(({ data }) => {
            if (data.code <= 0) {
              this.$toastError(data)
              return
            }
            if (data.info.change === 'Y') {
              localStorage.setItem(SESSION_VARS.EMAIL, this.email)
              localStorage.setItem('access', data.info.access)
              this.$router.push('/view/new/password')
              return
            }
            const token =
              typeof data.info === 'object' ? data.info.token : data.info
            localStorage.setItem(SESSION_VARS.TOKEN, token)
            localStorage.removeItem(SESSION_VARS.MENU)
            localStorage.removeItem(SESSION_VARS.CURRENT_COMPANY)
            localStorage.setItem(SESSION_VARS.EMAIL, this.email)
            localStorage.setItem(SESSION_VARS.USERNAME, data.info.username)
            window.location.href = this.home
          })
          .finally(() => {
            this.loading = false
          })
      })
    },

    // Método para iniciar sesión con Microsoft OAuth
    loginWithMicrosoft() {
      this.loading = true
      OAuthEndpoints.loginWithMicrosoft()
    },
    // Procesar callback de OAuth
    processOAuthCallback() {
      this.loading = true
      const tokenOAuth2 = consumeCookie(SESSION_VARS.OAUTH2_TOKEN)
      if (!tokenOAuth2) {
        this.$toastError(this.$t('loginWords.authLoginError'))
        return
      }

      const token = `${SESSION_VARS.BEARER_PREFIX} ${tokenOAuth2}`
      localStorage.setItem(SESSION_VARS.TOKEN, token)
      window.location.href = this.home
    }
  }
}
</script>
<style>
.login-register-bg {
  margin: 0 auto;
  background-size: cover;
  background: url(../../assets/images/background/lancaster_1080_1-100.jpg) no-repeat fixed center center;
}

.login-register-box {
  max-width: 400px;
}

.logo-cliente {
  width: 150px;
  height: 150px;
  border-radius: 150px;
  box-shadow: 2px 2px 10px #3d3d3d44;
  position: relative;
  bottom: -75px;
  left: 30%;
}

.user-input .vs-icon {
  font-size: 1.6em;
  aspect-ratio: 1;
  height: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none !important;
}

.user-input .vs-icon::before {
  content: '';
  width: 1px;
  background-color: rgba(0, 0, 0, 0.1);
  position: absolute;
  height: 18px;
  bottom: 50%;
  left: 0;
  z-index: 9;
  transform: translateY(50%);
}

.password-container .button-container {
  height: 100% !important;
}

/* Estilos para la autenticación OAuth */
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 15px 0;
  color: #757575;
  font-size: 14px;
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
}

.separator::before {
  margin-right: 10px;
}

.separator::after {
  margin-left: 10px;
}

.oauth-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: #fff;
  color: #5e5e5e;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.oauth-button:hover {
  background-color: #f5f5f5;
  border-color: #bbb;
  color: #000000;
}

.ms-logo {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
</style>
